import React, { useState } from 'react'
import { Button, Icon, Message } from 'semantic-ui-react'
import RepeatableMerchandiseContainer from '@containers/repeatableMerchandiseContainer'
import { useMultipleMerchandiseParties } from '@EUForms/hooks/useMultipleMerchandiseParties'
import AuthorizationDetail from '../../parties/authorizationDetail'
import MarkedDeleted from '../markedDeleted'
import { useCurrentShipmentType } from '@hooks/useCurrentShipmentType'

const MERCH_PARTIES_LABEL = {
    CONSIGNEE: 'consigneeList',
    CONSIGNOR: 'consignorsList',
    AUTHORIZATION: 'authorizationsList',
    ADD_SUP_CHAIN_ACTOR: 'additionalSupplyChainActorsList',
}

const MerchandiseParties = (props) => {
    const { 
        translate, 
        invoiceId, 
        merchandiseId, 
        invoiceIndex, 
        itemIndex, 
        isMerchandiseDisabled,
        isRFIDisabled 
    } =props
    const { ...rest } = useMultipleMerchandiseParties({ invoiceId, merchandiseId, containerKey: 'merchandiseParties' })
    return (
        <div>
            <RepeatableMerchandiseContainer
                reducerName='invoiceReducer'
                containerKey='merchandiseParties'
                tableName={MERCH_PARTIES_LABEL.AUTHORIZATION}
                invoiceId={invoiceId}
                merchandiseId={merchandiseId}
                title="AUTHORIZATION"
                maxRowsAllowed={2}
                translate={translate}
                renderForm={(params) => <AuthorizationDetail
                    isItemsTab={true}
                    displayOwner={false}
                    invoiceId={invoiceId}
                    merchandiseId={merchandiseId}
                    invoiceIndex={invoiceIndex}
                    itemIndex={itemIndex}
                    {...params}
                    isMerchandiseDisabled={isMerchandiseDisabled}
                    isRFIDisabled={isRFIDisabled}
                />}
                {...rest}
                isAddDisabled={isMerchandiseDisabled}
            />
        </div>
    )
}

export default MerchandiseParties